// Firebase app, auth, and Firestore
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// authDomain is what Google’s account picker shows after “Continue to …”.
// Default stays the Firebase subdomain; set REACT_APP_FIREBASE_AUTH_DOMAIN to your
// production host (e.g. app.dwellia.co) once that domain is on Firebase Hosting
// and listed under Authentication → Settings → Authorized domains.
const firebaseConfig = {
  apiKey: "AIzaSyC-cjgeUS745p6cp-mlkhuKPCysGX2tS3c",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'furnishedfilter.firebaseapp.com',
  projectId: "furnishedfilter",
  storageBucket: "furnishedfilter.firebasestorage.app",
  messagingSenderId: "1060026149004",
  appId: "1:1060026149004:web:4020ca750261271e2ab3a9",
  measurementId: "G-23NEKDMFJL"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
